
// from https://firebase.google.com/docs/reference/rest/auth

export const CUSTOM_UNKNOWN_ERROR = '__CUSTOM_UNKNOWN_ERROR__';

export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND';
export const INVALID_PASSWORD = 'INVALID_PASSWORD';
export const USER_DISABLED = 'USER_DISABLED';
export const INVALID_OOB_CODE = 'INVALID_OOB_CODE';
export const EXPIRED_OOB_CODE = 'EXPIRED_OOB_CODE';
export const TOO_MANY_ATTEMPTS_TRY_LATER = 'TOO_MANY_ATTEMPTS_TRY_LATER';
export const EMAIL_EXISTS = 'EMAIL_EXISTS';
